import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'ngx-pagina-espera',
  templateUrl: './pagina-espera.component.html',
  styleUrls: ['./pagina-espera.component.scss']
})
export class PaginaEsperaComponent implements OnInit {

  public texto: String;
  
  constructor(@Inject(MAT_DIALOG_DATA) data,
  private dialogRef: MatDialogRef<PaginaEsperaComponent>) { 

    this.texto = data;

  }

  ngOnInit(): void {
  }

}
